// =============================================================================
// HandResultOverlay.tsh — Shows hand result after showdown
// Project: Texas Hold'em Social Casino
// =============================================================================
// Displays the winner(s), winning hand type, pot amount, and rake taken.

import React from 'react'
import { HandResult } from '../types'

interface HandResultOverlayProps {
  result: HandResult
  onDismiss: () => void
}

const HAND_LABELS: Record<string, string> = {
  high_card: 'High Card',
  one_pair: 'One Pair',
  two_pair: 'Two Pair',
  three_of_a_kind: 'Three of a Kind',
  straight: 'Straight',
  flush: 'Flush',
  full_house: 'Full House',
  four_of_a_kind: 'Four of a Kind',
  straight_flush: 'Straight Flush',
  royal_flush: 'Royal Flush',
  fold: 'Everyone Folded',
}

export default function HandResultOverlay({ result, onDismiss }: HandResultOverlayProps): React.ReactElement {
  React.useEffect(() => {
    const timer = setTimeout(onDismiss, 4000)
    return () => clearTimeout(timer)
  }, [onDismiss])

  return (
    <div className="hand-result" onClick={onDismiss}>
      <div className="hand-result-title">
        {result.winnerIds.length > 1 ? 'Split Pot!' : 'Winner!'}
      </div>
      <div className="hand-result-detail">
        {result.winnerIds.map(id => `Player ${id.slice(0, 6)}`).join(' & ')}
      </div>
      {result.winnerHand && (
        <div className="hand-result-detail">
          {HAND_LABELS[result.winnerHand] || result.winnerHand}
        </div>
      )}
      <div className="hand-result-pot">
        +{(result.potAmount - result.rakeAmount).toLocaleString()} chips
      </div>
      {result.rakeAmount > 0 && (
        <div style={{ fontSize: 11, color: '#888', marginTop: 4 }}>
          Rake: {result.rakeAmount}
        </div>
      )}
    </div>
  )
}
